import { AnyAction } from 'redux'

import {
  RESET_ERROR,
  RESET_SUBSCRIPTION_EXTEND_STATUS,
  RESET_SUBSCRIPTION_REFUND_OFFER_STATUS,
  RESET_SUBSCRIPTION_UPDATE_VARIANT,
  SET_APP_CONFIG,
  SET_APP_NAME,
  SET_ERROR,
  SET_REFUND_AMOUNT,
  SET_SOURCE,
  SET_SUBSCRIPTION,
  SET_SUBSCRIPTION_EXTEND_STATUS,
  SET_SUBSCRIPTION_REFUND_OFFER_STATUS,
  SET_SUBSCRIPTION_UPDATE_VARIANT,
  SET_TAX_AMOUNT,
  START_FETCHING,
  STOP_FETCHING,
} from 'root-redux/actions/common'

import { IAppConfig } from 'models/config.model'
import { ISubscription } from 'models/subscriptionsApi'

export const enum SubscriptionUpdateVariant {
  UNSUBSCRIBE = 'unsubscribe',
  UPGRADE = 'upgrade',
  PAUSE = 'pause',
  EXTEND = 'extend',
  ALREADY_EXTENDED = 'already_extended',
}

export const enum ExtendSubscriptionStatus {
  SUCCESS = 'success',
  ERROR = 'error',
}

export const enum RefundSubscriptionStatus {
  SUCCESS = 'success',
  ERROR = 'error',
}

const initState: ICommonState = {
  appName: '',
  isFetching: false,
  actionList: [],
  error: null,
  appConfig: null,
  source: '',
  taxAmount: 0,
  refundAmount: 0,
  selectedSubscription: null,
  subscriptionUpdateVariant: null,
  subscriptionExtendStatus: null,
  subscriptionRefundStatus: null,
}

export interface ICommonState {
  appName: string
  isFetching: boolean
  actionList: string[]
  error: any
  appConfig: IAppConfig | null
  source: string
  taxAmount: number
  refundAmount: number
  selectedSubscription: ISubscription | null
  subscriptionUpdateVariant: SubscriptionUpdateVariant | null
  subscriptionExtendStatus: ExtendSubscriptionStatus | null
  subscriptionRefundStatus: RefundSubscriptionStatus | null
}

export function commonReducer(
  state: ICommonState = initState,
  { type, payload = null }: AnyAction,
): ICommonState {
  switch (type) {
    case SET_APP_NAME: {
      return {
        ...state,
        appName: payload,
      }
    }
    case START_FETCHING: {
      return {
        ...state,
        isFetching: true,
        actionList: state.actionList.concat(payload),
      }
    }
    case STOP_FETCHING: {
      return {
        ...state,
        isFetching: !!payload.length,
        actionList: payload,
      }
    }
    case SET_ERROR: {
      return {
        ...state,
        error: payload,
      }
    }
    case RESET_ERROR: {
      return {
        ...state,
        error: null,
      }
    }
    case SET_SUBSCRIPTION_UPDATE_VARIANT: {
      return {
        ...state,
        subscriptionUpdateVariant: payload,
      }
    }
    case RESET_SUBSCRIPTION_UPDATE_VARIANT: {
      return {
        ...state,
        subscriptionUpdateVariant: null,
      }
    }
    case SET_SUBSCRIPTION_EXTEND_STATUS: {
      return {
        ...state,
        subscriptionExtendStatus: payload,
      }
    }
    case RESET_SUBSCRIPTION_EXTEND_STATUS: {
      return {
        ...state,
        subscriptionExtendStatus: null,
      }
    }
    case SET_SUBSCRIPTION_REFUND_OFFER_STATUS: {
      return {
        ...state,
        subscriptionRefundStatus: payload,
      }
    }
    case RESET_SUBSCRIPTION_REFUND_OFFER_STATUS: {
      return {
        ...state,
        subscriptionRefundStatus: null,
      }
    }
    case SET_APP_CONFIG: {
      return {
        ...state,
        appConfig: payload,
      }
    }
    case SET_SOURCE: {
      return {
        ...state,
        source: payload,
      }
    }
    case SET_TAX_AMOUNT: {
      return {
        ...state,
        taxAmount: payload,
      }
    }
    case SET_REFUND_AMOUNT: {
      return {
        ...state,
        refundAmount: payload,
      }
    }
    case SET_SUBSCRIPTION: {
      return {
        ...state,
        selectedSubscription: payload,
      }
    }
    default:
      return state
  }
}
